<script setup>
definePage({
  meta: {
    action: 'read',
    subject: 'subject',
  },
})
import { status } from '@/datas/subject'
import { getProjectId } from "@/utils/cdms"
import { isLockedProject } from '@/utils/project'
import { useESignatureStore } from "@/utils/stores/esignature"
import { toRaw } from 'vue'
 
import { VDataTable } from 'vuetify/labs/VDataTable'

import ConfirmDialogCustom from '@/components/dialogs/ConfirmDialogCustom.vue'
import dayjs from 'dayjs'

const { t } = useI18n()

const esignatureStore = useESignatureStore()
const page = ref(1)
const itemsPerPage = ref(10)

const currentTab = ref(0)

const headers =  ref([
  // {
  //   title: 'ID',
  //   key: 'subject_id',
  // },
  {
    title: t('Site Name'),
    key: 'site_name',
  },
  {
    title: t('Subject Name'),
    key: 'name',
  },
  { title: t('Chart No'),  key: 'chart_no' },
  { title: t('Subject Number'),  key: 'subject_no' },
  { title: t('Status'),  key: 'status' },
  { title: t('Assignment'),  key: 'Assignment' },
  { title: t('Move'),  key: 'Move' },
  { title: t('Edit'),  key: 'actions', sortable: false, width: "120px" },
])


const isModalVisible = ref(false)
const selectedAnimal = ref(null)
  
const scheduleToSend = ref(null) // 어떤 스케줄을 보내려는지 저장
const isConfirmDialogVisible2 = ref(false)


// const reservation = ref({
//   phone: '',
//   schedules: [
//     { day: 0, date: '2025-05-10', time: '09:00', sent: true, sentDate: '2025.05.12 00:00', answered: true, answeredDate: '2025.05.12 00:00' },
//     { day: 1, date: '2025-05-11', time: '09:00', sent: true, sentDate: '2025.05.12 00:00', answered: true, answeredDate: '2025.05.12 00:00' },
//     { day: 2, date: '2025-05-12', time: '09:00', sent: true, sentDate: '2025.05.12 00:00', answered: false },
//     { day: 3, date: '2025-05-13', time: '09:00', sent: false, answered: false },
//     { day: 4, date: '2025-05-14', time: '09:00', sent: false, answered: false },
//     { day: 5, date: '2025-05-15', time: '09:00', sent: false, answered: false },
//     { day: 6, date: '2025-05-16', time: '09:00', sent: false, answered: false },
//     { day: 7, date: '2025-05-17', time: '09:00', sent: false, answered: false },
//     { day: 14, date: '2025-05-24', time: '09:00', sent: false, answered: false },
//     { day: 28, date: '2025-06-07', time: '09:00', sent: false, answered: false },
//   ],
// })


const reservation = ref({
  phone: '',
  schedules: [
    { day: 0, date: '2025-05-10', time: '09:00', sent: false, answered: false, deleted: 1 },
    { day: 1, date: '2025-05-11', time: '09:00', sent: false, answered: false },
    { day: 2, date: '2025-05-12', time: '09:00', sent: false, answered: false },
    { day: 3, date: '2025-05-13', time: '09:00', sent: false, answered: false },
    { day: 4, date: '2025-05-14', time: '09:00', sent: false, answered: false },
    { day: 5, date: '2025-05-15', time: '09:00', sent: false, answered: false },
    { day: 6, date: '2025-05-16', time: '09:00', sent: false, answered: false },
    { day: 7, date: '2025-05-17', time: '09:00', sent: false, answered: false },
    { day: 14, date: '2025-05-24', time: '09:00', sent: false, answered: false, deleted: 1 },
    { day: 28, date: '2025-06-07', time: '09:00', sent: false, answered: false, deleted: 1 },
  ],
})

const selectedResponse = ref(null)
const isResponseDialogVisible = ref(false)


const scheduleSnackbarMessage = ref('')
const isScheduleSnackbarVisible = ref(false)

const editableResponse = ref({
  day: 0,
  subjectId: '',
  itchDate: '',
  itchLevel: 0,
  note: '',
})

const editResponse = resp => {
  console.log("editResponse", resp)
  console.log("selectedAnimal.value", selectedAnimal.value)

  
  editableResponse.value = {
    day: resp.day,
    subjectId: selectedAnimal.value.subject_no?.toString() || '', // 필요 시 넣기
    itchDate: resp.itchDate || '',
    itchLevel: resp.itchLevel || 0,
    note: resp.note || '',
  }
  isResponseDialogVisible.value = true
}

const submitEditedResponse = async () => {

  if (!editableResponse.value.reason || editableResponse.value.reason.trim() === '') {
    alert('변경사유는 필수입니다.')
    
    return
  }

  if (!editableResponse.value.itchDate) {
    alert('날짜를 입력해주세요.')
    
    return
  }
  
  const payload = {
    subjectId: editableResponse.value.subjectId?.toString(),
    schedule: editableResponse.value.day?.toString().replace(/\D/g, ''),
    date: editableResponse.value.itchDate,
    level: parseFloat(editableResponse.value.itchLevel.toFixed(1)),
    note: editableResponse.value.note,
    reason: editableResponse.value.reason,
    projectId: getProjectId(),
  }

  console.log('📤 수정 요청 payload:', payload)

  try {
    const { data, error: apiError } = await $api('/responses', {
      method: 'POST',
      body: payload,
      onResponseError({ response }) {
        console.error('❗ API 응답 오류:', response._data)
      },
    })

    if (apiError?.value) {
      console.error('❌ 제출 실패:', apiError.value)
      alert('수정 중 오류가 발생했습니다. 다시 시도해주세요.')
      
      return
    }
    isResponseDialogVisible.value = false
    await fetchSubjects()
    await openResponseDetail(selectedAnimal.value)

    console.log('📥 subjects 갱신 완료')

  } catch (e) {
    console.error('❌ 예외 발생:', e)
    alert('알 수 없는 오류가 발생했습니다.')
  }
}




const statusText = val => {
  return status.find(({ value }) => value == val)?.text
}

const projectLocked = ref(await isLockedProject())

const {
  data: subjectsData,
  execute: fetchSubjects,
} = await useApi(createUrl('/subjects', {
  query: {
    projectId: getProjectId(),
  },
}))

const subjects = computed(() => subjectsData.value)

const updateOptions = options => {
  page.value = options.page
}

const deleteItem = (item, type="Delete") => {
  const work = type == "Delete" ? "삭제" : "복원"

  esignatureStore.$reset()
  esignatureStore.options ={
    title: work + "하는 사유를 입력해 주세요.",
    subTitle: work + " 사유",
    item,
    type,
  }
  esignatureStore.isDialogVisible = true
}

const setConfirm = async ({ result, options  }) => {

  if(result) {
    if(options.value.type == "Restore") {
      const deleteResult = await $api(`/subjects/restore/${options.value.item.id}`, { method: 'DELETE',
        body: { reason: options.value.reason } })
    } else {
      const deleteResult = await $api(`/subjects/${options.value.item.id}`, { method: 'DELETE',
        body: { reason: options.value.reason } })
    }
    fetchSubjects()
  }
}

const subjectHistory = ref([])
const isListSubjectHistoryVisible = ref(false)

const showHistory = async item => {
  const {
    data,
  } = await useApi(createUrl(`/subjects/${item.id}/history`, {
    query: {
    },
  }))

  subjectHistory.value = data.value
  isListSubjectHistoryVisible.value = true
}

function checkCondition(item) {
  console.log('조건 확인 클릭됨:', item)

  // 실제 조건 확인 로직 추가
}

function startVisit(item) {
  console.log('방문 시작 클릭됨:', item)

  // 실제 방문 시작 로직 추가
}

function toggleDeleteSchedule(schedule) {
  schedule.deleted = !schedule.deleted
}

function showScheduleSnackbar(message) {
  scheduleSnackbarMessage.value = message
  isScheduleSnackbarVisible.value = true
}


async function sendSchedule(schedule) {

  if (!selectedAnimal.value.phone || selectedAnimal.value.phone.trim() === '') {
    showScheduleSnackbar('전화번호를 먼저 입력해주세요.')
    
    return
  }

  // ✅ 날짜 확인
  if (!schedule.date || schedule.date.trim() === '') {
    showScheduleSnackbar('날짜를 먼저 선택해주세요.')
    
    return
  }

  // ✅ 시간 확인
  if (!schedule.time || schedule.time.trim() === '') {
    showScheduleSnackbar('시간을 먼저 선택해주세요.')
    
    return
  }
  try {
    // API 호출 예시
    // const response = await $api('/schedules/send', {
    //   method: 'POST',
    //   body: {
    //     date: schedule.date,
    //     time: schedule.time,
    //     day: schedule.day,
    //     phone: "01040689276",
    //     subjectId: selectedAnimal.value?.id, // 동물 ID 기준
    //   },
    // })

    console.log(selectedAnimal)
    console.log(selectedAnimal.value.subject_no)

    const response = await $api('/schedules/send', {
      method: 'POST',
      body: {
        "date": schedule.date,
        "time": schedule.time,
        "day": schedule.day,
        "phone": selectedAnimal.value.phone,
        "subjectId": selectedAnimal.value.id,
        "subjectNo": selectedAnimal.value.subject_no,
        "hospitalName": selectedAnimal.value.site_name,
        "subjectName": selectedAnimal.value.name,
        "projectId": getProjectId(),
      },
    })

   


    // 성공 시 처리
  } catch (error) {
    console.error('발송 실패:', error)
    showScheduleSnackbar('발송 중 오류가 발생했습니다. 다시 시도해주세요.')

    // 사용자에게 실패 메시지를 보여주고 싶으면 여기에 추가
  }
}



function formatPhoneNumber(phone) {
  if (!phone) return ''
  const digits = phone.replace(/\D/g, '') // 숫자만 추출

  if (digits.length === 11) {
    return digits.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3')
  } else if (digits.length === 10) {
    return digits.replace(/(\d{3})(\d{3,4})(\d{4})/, '$1-$2-$3')
  } else {
    return phone // 형식이 이상할 경우 그대로 출력
  }
}


// function savePhone(item) {
//   item.phone = item.editPhone
//   item.isEditingPhone = false
// }
async function savePhone(item) {
  const newPhone = item.editPhone

  try {
    const { data, error } = await $api(`/subjects/${item.id}/phone`, {
      method: 'PATCH',
      body: { phone: newPhone },
    })

    if (error?.value) {
      throw new Error('서버 오류 발생')
    }

    item.phone = newPhone
    item.isEditingPhone = false

    // 선택적으로 알림 메시지 표시
    isPhoneSnackbarVisible.value = true

  } catch (e) {
    console.error('전화번호 저장 실패:', e)
    error.value = '전화번호 저장에 실패했습니다. 다시 시도해주세요.'

    // 롤백
    item.editPhone = item.phone
    item.isEditingPhone = false
  }
}



function confirmSendSchedule(schedule) {
  console.log(schedule)
  console.log(schedule)
  if (!schedule.deleted) {

    try {
      console.log('👉 schedule:', schedule)

      if (typeof isConfirmDialogVisible2.value === 'undefined') {
        console.error('❌ isConfirmDialogVisible2 is undefined!')
      } else {
        console.log('✅ isConfirmDialogVisible2:', isConfirmDialogVisible2)
        console.log('✅ isConfirmDialogVisible2.value:', isConfirmDialogVisible2.value)
      }

      if (!schedule) {
        console.error('❌ schedule is undefined or null!')
      } else { 
        console.log('schedu')
        scheduleToSend.value = toRaw(schedule)

        console.log('📦 scheduleToSend.value set:', scheduleToSend.value)
      }

      isConfirmDialogVisible2.value = true

      console.log('🚀 isConfirmDialogVisible2.value after set TRUE:', isConfirmDialogVisible2.value)

    } catch (err) {
      console.error('🔥 ERROR in click handler:', err)
    }

  }
}


function cancelPhoneEdit(item) {
  item.editPhone = item.phone
  item.isEditingPhone = false
}

// subjects 데이터 초기화 시 아래 상태도 추가
watch(subjects, () => {
  if (subjects.value) {
    subjects.value.forEach(item => {
      item.isEditingPhone = false
      item.editPhone = item.phone
    })
  }
})

watch(() =>reservation.value.schedules[0].date, newDate => {
  if (!newDate) return

  const baseDate = dayjs(newDate)

  reservation.value.schedules.forEach((schedule, index) => {
    if (index === 0) return // Day 0은 그대로 유지
    const offsetDay = schedule.day
    const newScheduledDate = baseDate.add(offsetDay, 'day').format('YYYY-MM-DD')

    schedule.date = newScheduledDate
  })
})

watch(() => reservation.value.schedules[1].date, newDate => {
  if (!newDate) return

  const baseDate = dayjs(newDate)
  const baseDay = reservation.value.schedules[1].day // Day 1

  reservation.value.schedules.forEach(schedule => {
    const offset = schedule.day - baseDay

    schedule.date = baseDate.add(offset, 'day').format('YYYY-MM-DD')
  })
})

const isSnackbarVisible = ref(false)
const isPhoneSnackbarVisible = ref(false)



onMounted(() => {
  isSnackbarVisible.value = true
})

const search = ref('')

const filterItems = [
  { value: "site_name", title: "기관명" },
  { value: "name", title: "동물(검체)이름" },
  { value: "subject_no", title: "식별번호" },
]

const filterItem = ref('name')

const filterText = (value, query, item) => {
  return value != null &&  query != null &&
        typeof value === 'string' &&
        item.columns[filterItem.value].toLowerCase().indexOf(query.toLowerCase()) !== -1
}

watch(() => [search.value, filterItem.value], () => {
  page.value = 1
})



async function openReservationModal(animal) {
  selectedAnimal.value = animal


  try {
    const { data } = await useApi(`/schedules/fetch/${animal.id}`)

    console.log(data)
    if (data.value && Array.isArray(data.value)) {
      reservation.value.schedules = data.value.map(item => ({
        ...item,
        sent: item.sent,
        answered: item.answered || false,
        sentDate: item.sentDate || '',
        answeredDate: item.answeredDate || '',
        deleted: item.deleted || false,
      }))
    } else {
      // fallback: 기본 스케줄 (예: 응답이 없거나 에러)
      reservation.value.schedules = defaultSchedules()
    }
  } catch (error) {
    console.error('예약 불러오기 실패:', error)
    reservation.value.schedules = defaultSchedules()
  }
  
  isModalVisible.value = true
}

// function saveReservation() {
//   if (selectedAnimal.value) {
//     selectedAnimal.value.phone = reservation.value.phone
//     selectedAnimal.value.scheduled = true
//   }
//   isModalVisible.value = false
// }
async function saveReservation() {
  if (!selectedAnimal.value) return

  try {
    const payload = {
      subjectId: selectedAnimal.value.id, // 또는 subjectId
      projectId: getProjectId(),
      schedules: reservation.value.schedules.map(item => ({
        day: item.day,
        date: item.date,
        time: item.time,
        deleted: item.deleted ?? false,
      })),
    }

    console.log(payload)

    const { data, error } = await $api('/schedules/bulk-save', {
      method: 'POST',
      body: payload,
    })

    if (error?.value) throw new Error('저장 실패')

    isModalVisible.value = false
    isSnackbarVisible.value = true

  } catch (e) {
    console.error('[saveReservation 오류]', e)
    alert('예약 저장 중 오류가 발생했습니다.')
  }
}


async function saveReservationWithoutClosing() {
  if (!selectedAnimal.value) return

  try {
    const payload = {
      subjectId: selectedAnimal.value.id, // 또는 subjectId
      projectId: getProjectId(),
      schedules: reservation.value.schedules.map(item => ({
        day: item.day,
        date: item.date,
        time: item.time,
        deleted: item.deleted ?? false,
      })),
    }

    console.log(payload)

    const { data, error } = await $api('/schedules/bulk-save', {
      method: 'POST',
      body: payload,
    })

    if (error?.value) throw new Error('저장 실패')
 
    isSnackbarVisible.value = true

  } catch (e) {
    console.error('[saveReservation 오류]', e)
    alert('예약 저장 중 오류가 발생했습니다.')
  }
}

async function openResponseDetail(animal) {
  console.log("openResponseDetail", animal)
  selectedAnimal.value = animal

  try {
    const { data } = await useApi(`/schedules/fetch/${animal.id}`)

    console.log(data)
    if (data.value && Array.isArray(data.value)) {
      animal.responses = data.value.map(item => ({
        ...item,
        result: item.result || '-',  // null일 경우 대비
      }))
    } else {
      animal.responses = []  // 데이터 없을 경우 빈 배열
    }
  } catch (error) {
    console.error('응답 데이터 불러오기 실패:', error)
    animal.responses = []
  }
}

const handleConfirmSend = async result => {
  console.log('🟢 handleConfirmSend called with:', result)

  if (result) {
    console.log('🚀 발송 진행합니다!', scheduleToSend.value)
    if (scheduleToSend.value) {
      await saveReservationWithoutClosing() 
      await sendSchedule(scheduleToSend.value)

      await openReservationModal(selectedAnimal.value)
      scheduleToSend.value = null // 초기화
    }
  } else {
    console.log('❌ 발송 취소됨')

    // 취소 시 할 추가 처리 있으면 여기에
  }
}
</script>

<template>
  <h3 class="text-lg font-semibold mb-8">
    보호자 설문
  </h3>
  <VSnackbar
    v-model="isSnackbarVisible"
    :timeout="2000"
    location="top"
  >
    처음 동물등록시 전화번호를 등록하고 메시지 예약 완료해주세요.
  </VSnackbar>
  <VSnackbar
    v-model="isPhoneSnackbarVisible"
    :timeout="2000"
    location="top"
  >
    전화번호가 저장되었습니다.
  </VSnackbar>
 

  <ConfirmDialogCustom
    v-model="isConfirmDialogVisible2"
    confirm-title="즉시 발송 확인"
    confirm-msg="설문을 지금 바로 발송하시겠습니까?"
    confirmation-question="즉시 발송을 진행할까요?"
    cancel-msg="취소" 
    @confirm="handleConfirmSend"
  />



  <VSnackbar
    v-model="isScheduleSnackbarVisible"
    :timeout="3000"
    location="top"
    color="error"
  >
    {{ scheduleSnackbarMessage }}
  </VSnackbar>

  <VTabs
    v-model="currentTab"
    class="v-tabs-pill"
  >
    <VTab>평가지 발송</VTab>
    <VTab>결과 확인(수정)</VTab>
  </VTabs>

  <div v-show="currentTab === 0">
    <!-- 탭 1: 평가지 발송 화면 -->
    <VCard class="v-card-content">
      <VCardText>
        <VDataTable
          :headers="[
            { title: '동물 이름', key: 'name' },
            { title: '식별번호', key: 'subject_no' },
            { title: '전화번호 (보호자)', key: 'phone', sortable: false },
            { title: '메세지 예약', key: 'sms', sortable: false },
            { title: '예약 현황', key: 'status', sortable: false }
          ]"
          :items="subjects"
          :page="page"
          :items-per-page="itemsPerPage"
          class="elevation-1 custom-table"
          @update:page="val => page = val"
        >
          <template #item.name="{ item }">
            {{ item.name }}
          </template>

          <template #item.subject_no="{ item }">
            {{ item.subject_no }}
          </template>

          <template #item.phone="{ item }">
            <div class="d-flex align-center">
              <div v-if="!item.isEditingPhone">
                <span>{{ formatPhoneNumber(item.phone) || '전화번호 없음' }}</span>
                <VBtn
                  icon
                  size="x-small"
                  variant="text"
                  @click="item.isEditingPhone = true"
                >
                  <VIcon icon="tabler-edit" />
                </VBtn>
              </div>
              <div
                v-else
                class="d-flex align-center"
              >
                <VTextField
                  v-model="item.editPhone"
                  density="compact"
                  hide-details
                  style="inline-size: 140px"
                  placeholder="전화번호 입력"
                />
                <VBtn
                  icon
                  size="x-small"
                  variant="text"
                  @click="savePhone(item)"
                >
                  <VIcon icon="tabler-check" />
                </VBtn>
                <VBtn
                  icon
                  size="x-small"
                  variant="text"
                  @click="cancelPhoneEdit(item)"
                >
                  <VIcon icon="tabler-x" />
                </VBtn>
              </div>
            </div>
          </template>

          <template #item.sms="{ item }">
            <VBtn
              color="default"
              class="blueBtn"
              @click="openReservationModal(item)"
            >
              메시지 예약 관리
            </VBtn>
          </template>

          <template #item.status="{ item }">
            <template v-if="item.schedule_count > 0">
              예약완료 / 발송완료({{ item.sent_count }}건)
            </template>
            <template v-else>
              예약 가능
            </template>
          </template>
        </VDataTable>
      </VCardText>
    </VCard>
  </div>

  <div v-show="currentTab === 1">
    <!-- 탭 2: 결과 확인 화면 -->
    <div class="d-flex gap-4 v-card-content">
      <!-- 왼쪽: 테이블 -->
      <VCard class="grow">
        <VCardText>
          <VDataTable
            :headers="[
              { title: '동물 이름', key: 'name' },
              { title: '식별번호', key: 'subject_no' },
              { title: '응답지 보기', key: 'actions', sortable: false },
              { title: '응답 현황', key: 'status', sortable: false },
            ]"
            :items="subjects"
            :page="page"
            :items-per-page="itemsPerPage"
            class="elevation-1 custom-table"
            @update:page="val => page = val"
          >
            <template #item.name="{ item }">
              {{ item.name }}
            </template>
            <template #item.subject_no="{ item }">
              {{ item.subject_no }}
            </template>

            <template #item.actions="{ item }">
              <VBtn
                color="primary"
                size="small"
                @click="openResponseDetail(item)"
              >
                응답 결과 확인
              </VBtn>
            </template>

            <template #item.status="{ item }">
              {{ item.answered_count }} / 10 
            </template>
          </VDataTable>
        </VCardText>
      </VCard>

      <!-- 오른쪽: 상세 응답 결과 -->
      <VCard
        v-if="selectedAnimal"
        class="grow"
        style="max-inline-size: 600px;"
      >
        <VCardTitle>응답 상세 : 동물이름 - {{ selectedAnimal.name }}</VCardTitle>

        <VCardText class="margin-20">
          <div class="d-flex justify-space-between font-weight-bold text-grey mb-2 px-2">
            <div style="inline-size: 35%">
              평가일
            </div>
            <div style="inline-size: 45%">
              응답결과
            </div>
           
            <div
              style="inline-size: 20%"
              class="text-right"
            >
              응답지 보기
            </div>
          </div>

          <VList
            lines="two"
            class="px-0"
          >
            <VListItem
              v-for="(resp, idx) in selectedAnimal.responses"
              :key="idx"
              class="border-b px-2"
            >
              <div class="d-flex justify-space-between align-start w-100">
                <!-- 평가일 -->
                <div
                  style="inline-size: 35%"
                  class="text-sm"
                >
                  Day {{ resp.day }}<br>({{ resp.date }})
                </div>

                <!-- 응답 결과 -->
                <div
                  style="inline-size: 45%"
                  class="text-sm"
                >
                  <template v-if="!resp.itchDate && !resp.itchLevel && !resp.note">
                    - / - / -
                  </template>
                  <template v-else>
                    {{ resp.itchDate || '-' }} / {{ resp.itchLevel ?? '-' }} / {{ resp.note || '-' }} / {{ resp.reason || '-' }}
                  </template>
                </div>

              
                <!-- 버튼 -->
                <div
                  style="inline-size: 20%"
                  class="text-right"
                >
                  <VBtn
                    size="x-small"
                    variant="outlined"
                    @click="editResponse(resp)"
                  >
                    보기/수정
                  </VBtn>
                </div>
              </div>
            </VListItem>
          </VList>
        </VCardText>
      </VCard>
    </div>
  </div>
  

  <!-- 예약 모달 -->
  <VDialog
    v-model="isResponseDialogVisible"
    max-width="600"
  >
    <VCard>
      <VCardTitle class="text-h6">
        응답 수정 - Day {{ editableResponse.day }}
      </VCardTitle>

      <VCardText>
        <VForm @submit.prevent="submitEditedResponse">
          <VTextField
            v-model="editableResponse.itchDate"
            label="평가일"
            type="date"
            density="comfortable"
            hide-details
          />
          <div style="display: flex;align-items: center; justify-content: center;">
            <div style="margin-block-start:20px;">
              가려움 정도 :{{ parseFloat(editableResponse.itchLevel.toFixed(1)) }}
            </div>
            <VSlider
              v-model="editableResponse.itchLevel"
              style="margin-block-start:20px;"
              label=""
              min="0"
              max="10"
              step="0.1"
              thumb-label
              hide-details
            />
          </div>
          <VTextarea
            v-model="editableResponse.note"
            style="margin-block-start:20px;"
            label="특이사항"
            auto-grow
            rows="2"
            hide-details
          />
          <VTextarea
            v-model="editableResponse.reason"
            style="margin-block-start:20px;"
            label="변경사유"
            auto-grow
            rows="2"
            hide-details
            :rules="[v => !!v || '변경사유는 필수입니다.']"
          />
        </VForm>
      </VCardText>

      <VCardActions class="justify-end">
        <VBtn
          text
          @click="isResponseDialogVisible = false"
        >
          취소
        </VBtn>
        <VBtn
          color="primary"
          @click="submitEditedResponse"
        >
          저장
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>



  <VDialog
    v-model="isModalVisible"
    width="950"
  >
    <VCard>
      <VCardTitle>
        <strong>📅 설문 예약 상세 설정</strong>
        <div class="text-subtitle-2 text-grey">
          ◦ 동물 이름 : {{ selectedAnimal?.name }}  
        </div>
      </VCardTitle>
      <VCardText>
        <VTable>
          <thead>
            <tr>
              <th>평가일</th>
              <th>날짜</th>
              <th>시간</th>
              <th>발송완료</th>
              <th>응답완료</th>
              <th>즉시 보내기/삭제</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(schedule, idx) in reservation.schedules"
              :key="idx"

              :class="{ 'deleted-row': schedule.deleted }"
            >
              <td>Day {{ schedule.day }}</td>
              <td>
                <VTextField
                  v-model="schedule.date"
                  type="date"
                  density="compact"
                />
              </td>
              <td>
                <VTextField
                  v-model="schedule.time"
                  type="time"
                  density="compact"
                />
              </td>
              <td>
                <span v-if="schedule.sent">⭕<br><template v-if="schedule.sentDate">({{ schedule.sentDate }})</template></span>
                <span v-else>-</span>
              </td>
              <td>
                <span v-if="schedule.answered">⭕<br><template v-if="schedule.answeredDate">({{ schedule.answeredDate }})</template></span>
                <span v-else>-</span>
              </td>
              <td>
                <VIcon
                  icon="tabler-send"
                  class="me-2"
                  :color="schedule.deleted ? 'grey' : 'primary'"
                  @click="confirmSendSchedule(schedule)"
                />
                <VIcon
                  :icon="schedule.deleted ? 'tabler-rotate-rectangle' : 'tabler-trash'"
                  :color="schedule.deleted ? 'green' : 'default'"
                  style="cursor: pointer;"
                  @click="() => toggleDeleteSchedule(schedule)"
                />
              </td>
            </tr>
          </tbody>
        </VTable>
      </VCardText>
      <VCardActions class="justify-end">
        <VBtn @click="isModalVisible = false">
          변경취소
        </VBtn>
        <VBtn
          color="primary"
          @click="saveReservation"
        >
          수정 및 발송예약
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<style lang="scss" scoped>
.deleted {
  text-decoration: line-through;
}

.justify-start{
  display: flex;
  justify-items: start;
}

.v-data-table .v-table__wrapper > table > thead > tr > th,
.v-data-table .v-table__wrapper > table > tbody > tr > th {
  font-size: 15px;
}

.elevation-1 .v-data-table .v-table__wrapper > table > thead > tr > th {
  background-color: #f8f8f8;
  font-size: 15px;
  font-weight: 600;
}

.text-subtitle-2{
  font-weight: bold;
  margin-block-start: 10px;
}

.v-tabs-pill{
  margin-block-end: 30px;
}

.v-card-content{
  margin-block-start: 20px;
}

.blueBtn{
  background:#E7E6FD ;
  color:#7367F0 ;
}

.v-list-item__title {
  font-weight: 600;
}

.vv-card-title {
  padding: 1rem;
  background-color: #f9f9f9;
}

.grow{
  inline-size: 50%;
}

.border-b {
  border-block-end: 1px solid #e0e0e0;
}

.text-sm {
  font-size: 14px;
}

.margin-20{
  margin-block-start: 20px;
}

.deleted-row {
  opacity: 0.6;
  text-decoration: line-through;
}

.vertical-range-guide {
  border-radius: 10px;
  appearance: slider-vertical;
  background: linear-gradient(to top, #f44336, #ff9800, #ffeb3b, #4caf50);
  block-size: 400px;
  inline-size: 10px;
  margin-block: 1rem;
  margin-inline: auto;
}

.itch-level-guide {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  block-size: 400px;
  font-size: 0.9rem;
  line-height: 1.4;
  margin-block-start: -380px; /* 슬라이더 옆에 위치시키기 위한 보정 */
  margin-inline-start: 50px;
  padding-inline-start: 1.5rem;
}



:deep(.custom-table .v-table__wrapper table) {
  th {
    background: #F3F5F8 !important;  /* 밝은 회색 배경 */
    border-block-end: 1px solid #eee;
    color: #909090 !important;       /* 연한 회색 텍스트 */
    font-size: 13px;
    font-weight: 500;
    padding-block: 10px;
    padding-inline: 12px;
  }

  td {
    border-block-end: 1px solid #E8EBEE;
    color: #444;
    font-size: 14px;
    padding-block: 8px;
    padding-inline: 12px;
  }

  tr:hover td {
    background-color: #f9f9fc; /* hover 시 은은한 하이라이트 */
  }
}

:deep(.custom-table .v-badge__badge) {
  border-radius: unset;
  font-size: 8px;
  margin-inline-start: 5px;
  min-inline-size: 10px;
}

:deep(.v-card-item) {
  padding: 12px;
}
</style>
